export const prop = <T, TKey extends keyof T>(key: TKey) => (data: T): T[TKey] => data[key];
